import { Polyline } from "@react-google-maps/api"
import React from "react"
import useRouteStore from "../../routes.store"

const FinalRoutePolyline = () => {
  const path = useRouteStore(store => store.data.googleMapRoute?.path)
  const color = useRouteStore(store => {
    const code = store.data.colorCode
    return code?.id || code
  })
  if (!path) return null

  return (
    <Polyline
      options={{
        strokeColor: color,
      }}
      path={path}
    />
  )
}

export default FinalRoutePolyline
